import { useCallback, useState } from 'react';

export interface IUseLocationSuggestValue {
  togglePopup(value: boolean): void;
  getLocationSuggest(value: string): void;
}
export const useLocationSuggestValue = ({ getLocationSuggest, togglePopup }: IUseLocationSuggestValue) => {
  const [suggestValue, setSuggestValue] = useState('');

  const onSuggestionValueChange = useCallback(
    (value: string) => {
      setSuggestValue(value);
      getLocationSuggest(value);
    },
    [setSuggestValue, getLocationSuggest],
  );

  const clearSuggestValue = useCallback(() => {
    setSuggestValue('');
    togglePopup(false);
  }, [togglePopup]);

  return {
    suggestValue,
    onSuggestionValueChange,
    clearSuggestValue,
  };
};
